// extracted by mini-css-extract-plugin
export default {"label":"DisplayLocationTime_label__+GhLh"};